import { render, staticRenderFns } from "./FeedTab.vue?vue&type=template&id=4019549a&scoped=true"
import script from "./FeedTab.vue?vue&type=script&lang=js"
export * from "./FeedTab.vue?vue&type=script&lang=js"
import style0 from "./FeedTab.vue?vue&type=style&index=0&id=4019549a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4019549a",
  null
  
)

export default component.exports